import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Jckla } from '../entity/Jckla-angular';


@Injectable({
  providedIn: 'root'
})
export class JcklaServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Jckla();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      LA001: '序號', LA002: '時間', LA003: '路徑URL', LA004: 'QueryFields', LA005: 'RequestContent', LA006: 'ResponseContent', LA007: '備註'
    };

    this.fieldNames = 'LA001,LA002,LA003,LA004,LA005,LA006,LA007';
    this.fieldLengths = { LA001: 10, LA002: 0, LA003: 255, LA004: 255, LA005: 0, LA006: 0, LA007: 255 };
    this.columnDefs = [
      { field: "LA001", headerName: "序號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "LA002", headerName: "時間", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "LA003", headerName: "路徑URL", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "LA004", headerName: "QueryFields", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "LA005", headerName: "RequestContent", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "LA006", headerName: "ResponseContent", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "LA007", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'JCKLA';
    this.isSys = false;
    this.sqlSelect = `SELECT JCKLA.*  FROM JCKLA`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY LA001`;
    this.keyFields = ['LA001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['LA001'];
    this.seqField = 'LA001';
    this.seqFieldLength = 10;
  }
  override async validateItem(item: Jckla): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Jckla): Promise<Jckla> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
